/* eslint-disable no-mixed-operators */
/*
 * @Author: your name
 * @Date: 2021-08-23 17:28:44
 * @LastEditTime: 2021-10-28 14:20:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zq/src/page/study/mathematics/action.ts
 */

import * as $api from './api';
import { evaluate } from 'mathjs';

export type fiveType = 'add' | 'subtr';
export const fiveTypeAdd: fiveType = 'add';
export const fiveTypeSubtr: fiveType = 'subtr';

function toAndSubtractIn5(number: number) {
    let decimalArray: Array<string> = [];
    let numberA = Math.ceil(number / 2); //a+b 生成的数量
    let numberB = Math.floor(number / 2); //a-b生成的数量
    decimalArray = decimalArray.concat(FiveFun(numberA, fiveTypeAdd));
    decimalArray = decimalArray.concat(FiveFun(numberB, fiveTypeSubtr));
    return decimalArray;
}

function toAndSubtractIn10(number: number) {
    let decimalArray: Array<string> = [];
    let numberA = Math.ceil(number / 2); //a+b 生成的数量
    let numberB = Math.floor(number / 2); //a-b生成的数量
    decimalArray = decimalArray.concat(FiveFun(numberA, fiveTypeAdd, 10));
    decimalArray = decimalArray.concat(FiveFun(numberB, fiveTypeSubtr, 10));
    return decimalArray;
}

function toAndSubtractIn20(number: number, type: fiveType) {
    let decimalArray: Array<string> = [];
    if (type === fiveTypeAdd) {
        decimalArray = decimalArray.concat(FiveFun(number, fiveTypeAdd, 20));
    } else {
        decimalArray = decimalArray.concat(FiveFun(number, fiveTypeSubtr, 20));
    }
    return decimalArray;
}

function toAndSubtractIn100(number: number) {
    let decimalArray: Array<string> = [];
    let numberA = Math.ceil(number / 2); //a+b 生成的数量
    let numberB = Math.floor(number / 2); //a-b生成的数量
    decimalArray = decimalArray.concat(FiveFun(numberA, fiveTypeAdd, 100));
    decimalArray = decimalArray.concat(FiveFun(numberB, fiveTypeSubtr, 100));
    return decimalArray;
}

/**
 * @description: 100加减混合运算
 * @param {number} number
 * @return {*}
 */
function toAndSubtractIn100Mixture(number: number) {
    console.log(number, 'toAndSubtractIn100Mixture')
    let decimalArray: Array<string> = [];
    decimalArray = decimalArray.concat(HybridFun(number, fiveTypeAdd, 100));
    return decimalArray;
}

/**
 * @description: 99乘法表
 * @param {number} num
 * @return {*}
 */
function multiplicationTables(num: number) {
    let array = [];
    for (let i = 0; i < num; i++) {
        let a = parseInt((Math.random() * 9).toString());
        let b = parseInt((Math.random() * 9).toString());
        let set = a + ' * ' + b + " =";
        array.push(set)
    }
    return array;
}

/**
 * @description: 除法表
 * @param {*}
 * @return {*}
 */
function divisionTables(num: number) {
    let array = [];
    for (let i = 0; i < num; i++) {
        let a = parseInt((Math.random() * 9).toString());
        let b = parseInt((Math.random() * 9).toString());
        if (a !== 0 && b !== 0) {
            let set = evaluate(a + ' * ' + b) + " ÷ " + a + " =";
            array.push(set)
        } else {
            i--;
        }
    }
    return array;
}

/**
 * @description: 除数带余数
 * @param {*}
 * @return {*}
 */
function divisionTablesRemainder(num: number,) {
    let array = [];
    for (let i = 0; i < num; i++) {
        let a = parseInt((Math.random() * 81).toString());
        let b = parseInt((Math.random() * 9).toString());
        if (a !== 0 && b !== 0 && a % b !== 0) {
            let set = a + " ÷ " + b + " =";
            array.push(set)
        } else {
            i--;
        }
    }
    return array;
}


/**
 * @description: 四则运算算法
 * @param {number} num
 * @return {*}
 */
function mixedOperation(num: number) {
    const maxNum = 89;
    let array: string[] = [];
    //  计算随机生成A和B，且100《a+b》1
    //  d = A+B或者A-b《100》1
    //  第三步计算随机生成100< c >1
    //  如果d 小于9则 c ? d,否则 d ? c
    //  便利顺序按乘除加减计算，要求乘积之和小于100 除数可以背整除，加法小于100，减法不为负数
    // 防止有0的出现，所以随机数少一个
    const ind = 0;
    const operation = (ind: number) => {
        if (ind === num) {
            return
        } else {
            let FirstNum: string = '';
            let a = evaluate(parseInt((Math.random() * maxNum).toString()) + '+' + 1);
            let b = evaluate(parseInt((Math.random() * maxNum).toString()) + '+' + 1);
            let c = evaluate(parseInt((Math.random() * maxNum).toString()) + '+' + 1);

            if (a < b) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                let symbol = (b - a) % 2 !== 0 ? evaluate(a + '+' + b) > maxNum ? '-' : '+' : '-';
                FirstNum = b + `${symbol}` + a;
            } else {
                let symbol = (a - b) % 2 !== 0 ? evaluate(b + '+' + a) > maxNum ? '-' : '+' : '-';
                FirstNum = a + `${symbol}` + b;
            }
            if (c >= 1 && c <= 9) {
                if (evaluate(FirstNum) % c === 0) { // 可以整除
                    FirstNum = "(" + FirstNum + ') ÷' + c + ' = ';
                } else if (evaluate(FirstNum + '*' + c) <= maxNum && evaluate(FirstNum) <= 9) {
                    FirstNum = "(" + FirstNum + ') *' + c + ' = ';
                } else if (evaluate(FirstNum + '+' + c) <= maxNum) {
                    FirstNum = FirstNum + '+' + c + ' = ';
                } else {
                    FirstNum = evaluate(FirstNum) > c ? FirstNum + '-' + c  + ' = ' : c + '- (' + FirstNum + ') = ';
                }
            } else if (evaluate(FirstNum + '+' + c) <= maxNum) { // 累加小于 98
                FirstNum = c % 2 !== 0 ? c + '+ (' + FirstNum + ') = ' : FirstNum + '+' + c + ' = ';
            } else {
                if (evaluate(FirstNum) > c) {
                    FirstNum = c % 2 !== 0 ? FirstNum + '-' + c + ' = ' : "(" + FirstNum + ") -" + c + ' = ';
                } else {
                    // eslint-disable-next-line no-useless-concat
                    FirstNum = c % 2 !== 0 ? c + '-' + FirstNum + ' = ' : c + "- (" + FirstNum + ")" + ' = ';
                }
            }
            array.push(FirstNum);
            ind++;
            operation(ind);
        }

    }
    operation(ind);
    return array
}

/**
 * @description: 整百整千加减法
 * @param {number} num
 * @return {*}
 */
function integerMath(num: number) {
    let decimalArray: any = [];
    let numberA = Math.ceil(num / 2); //a+b 生成的数量
    let numberB = Math.floor(num / 2); //a-b生成的数量
    decimalArray = decimalArray.concat(addTen(numberA, 100, false));
    decimalArray = decimalArray.concat(subtrTen(numberB, 100, false));
    return decimalArray;
}

function FiveFun(num: number, type: fiveType, numb: number = 5) {
    let array = [];
    for (let i = 0; i < num; i++) {
        let a = parseInt((Math.random() * numb).toString());
        let b = parseInt((Math.random() * numb).toString());
        if (type === fiveTypeAdd) {
            if (a - b > 0 && a !== 0 && b !== 0) {
                let set = a + ' - ' + b + " =";
                array.push(set)
            } else {
                i--;
            }
        } else {
            if (a + b <= numb && a !== 0 && b !== 0) {
                let set = a + ' + ' + b + " =";
                array.push(set)
            } else {
                i--;
            }
        }
    }
    return array;
}


function HybridFun(num: number, type: fiveType, numb: number = 5) {
    let array = [];
    for (let i = 0; i < num; i++) {
        let random1 = Math.round(Math.random() * 100) % 2;
        let random2 = Math.round(Math.random() * 100) % 2;
        let a = parseInt((Math.random() * numb).toString());
        let b = parseInt((Math.random() * numb).toString());
        let c = parseInt((Math.random() * numb).toString());

        if (a !== 0 && b !== 0 && c !== 0) {
            let siteL = a + $api.addAndSub[random1] + b;
            let siteR = siteL + $api.addAndSub[random2] + c;
            if (evaluate(siteL) > 0 && evaluate(siteL) < 100 && evaluate(siteR) > 0 && evaluate(siteR) <= 100) {
                array.push(siteR);
            } else {
                i--;
            }
        } else {
            i--;
        }
    }
    return array;
}


/**
 * @description: 10以内小数字加减运算
 * @param {number} number 题目数
 * @return {*}
 */
function inTenAdditionAndSubtraction(number: number) {
    let decimalArray: Array<{}> = [];
    let numberA = Math.ceil(number / 2); //a+b 生成的数量
    let numberB = Math.floor(number / 2); //a-b生成的数量
    decimalArray = decimalArray.concat(addTen(numberA, 1, false));
    decimalArray = decimalArray.concat(subtrTen(numberB, 1, false));
    return decimalArray;
}

function addTen(number: Number, multiple: number, isDecimal: boolean, numb: number = 2) {
    let array = [];
    for (let i = 0; i < number; i++) {
        let a = parseFloat((Math.random() * 10).toFixed(numb));
        let b = parseFloat((Math.random() * 10).toFixed(numb));
        if (a - b > 0) {
            let set = '';
            if (isDecimal) {
                set = a * multiple + ' - ' + (b * multiple) + " =";
            } else {
                set = Math.ceil(a) * multiple + ' - ' + Math.ceil(b) * multiple + " =";
            }
            array.push(set)
        } else {
            i--;
        }
    }
    return array;
}

function subtrTen(number: Number, multiple: number, isDecimal: boolean, numb: number = 2) {
    let array = [];
    for (let i = 0; i < number; i++) {
        let a = parseFloat((Math.random() * 10).toFixed(numb));
        let b = parseFloat((Math.random() * 10).toFixed(numb));
        if (a + b <= 10) {
            let set = ''
            if (isDecimal) {
                set = (a * multiple) + ' + ' + (b * multiple) + " =";
            } else {
                set = Math.ceil(a) * multiple + ' + ' + Math.ceil(b) * multiple + " =";
            }
            array.push(set)
        } else {
            i--;
        }
    }
    return array;
}

//100以内小数的加减法
function mathNum(numb: number) {
    // 随机生成numb个数
    let newNumb = generate(numb);
    let set = Array.from(new Set(newNumb));
    if (set.length != numb) {
        return ifQualified(set, numb);
    }
    return set
}

function ifQualified(set: any, number: number) {
    let newSet = set;
    while (newSet.length == number) {
        let arr = set.concat(generate(number - newSet.length));
        newSet.concat(arr);
    }
    return newSet;
}

/**
 * @description: 
 * @param {number} number
 * @return {*}
 */
function generate(number: number) {
    let newArr = [];//一次的集合
    for (let i = 1; i <= number; i++) {
        let a = parseFloat((Math.random() * i).toFixed(2));
        let b = parseFloat((Math.random() * i).toFixed(2));
        if (a + b <= 100 && a != parseInt(a.toString()) && b != parseInt(b.toString())) {
            let set = a + ' + ' + b + " = ";
            newArr.push(set)
        } else {
            i--;
        }
    }
    return newArr
}

/**
 * @description: 多位数乘1位数
 * @param {number} number
 * @return {*}
 */
function moreTake1(number: number) {
    let array = [];
    for (let i = 1; i <= number; i++) {
        let a = evaluate(parseInt((Math.random() * 998).toString()) + '+' + 1);
        let b = evaluate(parseInt((Math.random() * 8).toString()) + '+' + 1);
        array.push(a + " x " + b + "=")
    }
    return array
}

/**
 * @description: 分数运算
 * @param {number} number
 * @return {*}
 */
function scoreMath(number: number) {
    let array = [];
    for (let i = 1; i <= number; i++) {
        let a = evaluate(parseInt((Math.random() * 8).toString()) + '+' + 1);
        if (a !== 1) {
            let b = evaluate(parseInt((Math.random() * (a - 1)).toString()) + '+' + 1);
            let c = evaluate(parseInt((Math.random() * (a - 1)).toString()) + '+' + 1);
            if (b + c > a) {
                array.push(b > c ? b + '/' + a + ' - ' + c + '/' + a : c + '/' + a + ' - ' + b + '/' + a)
            } else {
                array.push(b + '/' + a + ' - ' + c + '/' + a)
            }
        } else {
            let b = evaluate(parseInt((Math.random() * 7).toString()) + '+' + 2);
            let c = evaluate(parseInt((Math.random() * (b - 1)).toString()) + '+' + 1);
            array.push(a + ' - ' + c + '/' + b)
        }
    }
    return array
}

/**
 * @description: 多位数除1位数
 * @param {number} number
 * @return {*}
 */
function divisionTake1(number: number) {
    let array: string[] = [];
    const ind = 0;
    const division = (ind: number) => {
        if (ind === number) {
        } else {
            let a = evaluate(parseInt((Math.random() * 998).toString()) + '+' + 1);
            let b = evaluate(parseInt((Math.random() * 7).toString()) + '+' + 2);
            if (a % b === 0) {
                array.push(a + " ÷ " + b + "=")
                ind++;
                division(ind)
            } else {
                division(ind)
            }
        }
    }
    division(ind)
    return array
}

/**
 * @description: 多位数乘1位数
 * @param {number} number
 * @return {*}
 */
function moreTakeN(number: number) {
    let array = [];
    for (let i = 1; i <= number; i++) {
        let a = evaluate(parseInt((Math.random() * 89).toString()) + '+' + 10);
        let b = evaluate(parseInt((Math.random() * 89).toString()) + '+' + 10);
        array.push(a + " x " + b + "=")
    }
    return array
}

/**
 * @description: 简单小数点加减法 随机整数加随机小数点
 * @param {number} number
 * @return {*}
 */
function decimalMeath(number: number) {
    let decimalArray: any = [];
    let numberA = Math.ceil(number / 2); //a+b 生成的数量
    let numberB = Math.floor(number / 2); //a-b生成的数量
    decimalArray = decimalArray.concat(addTen(numberA, 1, true, 1));
    decimalArray = decimalArray.concat(subtrTen(numberB, 1, true, 1));
    return decimalArray;
}


/**
 * @description: 3位数乘2位数
 * @param {number} number
 * @return {*}
 */
function thereTake2(number: number) {
    let array = [];
    for (let i = 1; i <= number; i++) {
        let a = evaluate(parseInt((Math.random() * 899).toString()) + '+' + 100);
        let b = evaluate(parseInt((Math.random() * 89).toString()) + '+' + 10);
        array.push(a + " x " + b + "=")
    }
    return array
}


/**
 * @description: 除数是两位数
 * @param {number} number
 * @return {*}
 */
function divisionTake2(number: number) {
    let array: string[] = [];
    const ind = 0;
    const division = (ind: number) => {
        if (ind === number) {
        } else {
            let a = evaluate(parseInt((Math.random() * 979).toString()) + '+' + 20);
            let b = evaluate(parseInt((Math.random() * 99).toString()) + '+' + 1);
            if (a % b === 0) {
                array.push(a + " ÷ " + b + "=")
                ind++;
                division(ind)
            } else {
                division(ind)
            }
        }
    }
    division(ind)
    return array
}


function decimal2(number: number) {
    let decimalArray: any = [];
    let numberA = Math.ceil(number / 2); //a+b 生成的数量
    let numberB = Math.floor(number / 2); //a-b生成的数量
    decimalArray = decimalArray.concat(addTen(numberA, 1, true));
    decimalArray = decimalArray.concat(subtrTen(numberB, 1, true));
    return decimalArray;
}


/**
 * @description: 多位数除2位数
 * @param {number} number
 * @return {*}
 */
function divisionTakeN(number: number) {
    let array: string[] = [];
    const ind = 0;
    const division = (ind: number) => {
        if (ind === number) {
        } else {
            let a = evaluate(parseInt((Math.random() * 998).toString()) + '+' + 1);
            let b = evaluate(parseInt((Math.random() * 97).toString()) + '+' + 2);
            if (a % b === 0) {
                array.push(a + " ÷ " + b + "=")
                ind++;
                division(ind)
            } else {
                division(ind)
            }
        }
    }
    division(ind)
    return array
}

/**
 * @description: 三年级万以内加减法
 * @param {number} number
 * @return {*}
 */
function thousandWithin(number: number) {
    let array = [];
    for (let i = 1; i <= number; i++) {
        let a = evaluate(parseInt((Math.random() * 998).toString()) + '+' + 1);
        let b = evaluate(parseInt((Math.random() * 998).toString()) + '+' + 1);
        if (a + b > 10000) {
            array.push(a > b ? a + " - " + b + "=" : b + " - " + a + "=")
        } else {
            array.push(a + " + " + b + "=")
        }
    }
    console.log('array', array)
    return array
}

function swap(array: Array<string>, a: number, b: number) {
    [array[a], array[b]] = [array[b], array[a]];
}

/**
 * @description: 打乱排序顺序
 * @param {Array} array
 * @return {*}
 */
function shuffle(array: Array<string>) {
    for (let i = array.length - 1; i > 0; i--) {
        const randomIndex = Math.floor((Math.random() * (i + 1)));
        swap(array, i, randomIndex);
    }
    return array;
}


export {
    toAndSubtractIn5, toAndSubtractIn10, toAndSubtractIn20, toAndSubtractIn100, toAndSubtractIn100Mixture,
    inTenAdditionAndSubtraction, multiplicationTables, divisionTables, divisionTablesRemainder, mixedOperation,
    integerMath, thousandWithin, moreTake1, scoreMath, divisionTake1, divisionTakeN, moreTakeN, decimalMeath,
    thereTake2, divisionTake2, decimal2, mathNum, shuffle,
};